import useSWR from 'swr';
import { Typography } from '@mui/material';
import { IRateCard } from '@modules/admin/Tools/LenderEditor/tabs/RateCards/queries';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { PdfViewer } from '@shared/components/PdfViewer';
import { SERVICES } from '@shared/constants/apiConfig';
import { Loader } from '@shared/enhancers/withLoader';
import { RelativeWrapper } from '@shared/styledComponents';
import { LocalTabContent } from '@styles/CommonStyles';

export const RateCardsInfo = ({ lenderId }: { lenderId: string }) => {
  const { data: rateCards, error, isLoading } = useSWR<IRateCard[]>(`${SERVICES.LENDER}/lenderdocuments/${lenderId}`);

  const fileContents = rateCards?.[0]?.fileContents;

  return (
    <RelativeWrapper>
      <LocalTabContent>
        {isLoading ? <Loader /> : rateCards && !error ? <PdfViewer fileSource={fileContents} /> :
          <Typography fontWeight='bold' justifyContent='center'>
            No Document Found
          </Typography>
        }
      </LocalTabContent>
    </RelativeWrapper>
  );
};
